module.exports = __webpack_public_path__ + "static/media/icon_bell.fd58929e.svg";